import { defineStore } from "pinia";
import dashboardsApi from "@/services/api/dashboardsApi";

export const useDashboardStore = defineStore("dashboard", {
  state: () => ({
    periods: [],
    loading: false,
    error: null,
  }),

  actions: {
    async fetchPeriodStats(companyId, params = {}) {
      this.loading = true;
      this.error = null;
      try {
        const response = await dashboardsApi.getPeriodStats(
          companyId,
          params
        );
        this.periods = response.data.periods;
      } catch (e) {
        this.error = "Не удалось загрузить статистику";
      } finally {
        this.loading = false;
      }
    },
  },
});
